import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button, IButtonProps } from '../../../ui';
import { useDiscoverTheme } from '../../../common/emotion';
import { SelectItem } from '../../../ui/dropdowns/select-dropdown';

export const SlicerOptionSelectOnlyButton = (props: IButtonProps) => {
  const { colors: { ContentText, TabHighlightDisabled } = {} as any } =
    useDiscoverTheme();
  return (
    <Button
      css={css({
        fontSize: 12,
        padding: '0px 2px',
        color: `${ContentText} !important`,
        marginRight: 10,
        backgroundColor: TabHighlightDisabled,
        '&:hover': {
          backgroundColor: TabHighlightDisabled,
        },
      })}
      {...props}
    />
  );
};

export const SlicerOptionColumn = styled.div({
  padding: 0,
});

export const SlicerOptionRow = styled(SelectItem)(
  ({
    theme: {
      colors: { ContentBackground, DropdownOptionHoverBackground } = {} as any,
    } = {} as any,
  }: any) =>
    css({
      paddingLeft: 0,
      paddingRight: 0,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: ContentBackground,
      '&:hover': css({
        backgroundColor: DropdownOptionHoverBackground,
      }),
    }),
) as any;
